<!--
 * @Author: yuanjianlong
 * @Description: 创建组计划抽屉
 * @Date: 2022-03-10 15:18:13
 * @LastEditTime: 2022-03-19 16:39:03
 * @FilePath: /teacher-h5/src/views/studentManage/studentAndGroup/groupDetails/components/addGroupPlanDrawer.vue
-->
<template>
  <a-drawer
    placement="right"
    :visible="visible"
    :destroy-on-close="true"
    width="100%"
    :body-style="bodyStyle"
    @close="onClose"
    class="video-drawer"
  >
    <template slot="title">
      {{ title }}
      <a-divider type="vertical" />
      课程ID: {{ classTypeId }}
    </template>
    <VideoPlayer
      v-if="visible"
      :ai-lesson-id="aiLessonId"
      :lesson-id="lessonId"
      :class-type-id="classTypeId"
      :companion-user-group-id="companionUserGroupId"
    />
  </a-drawer>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer/index.vue'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: String,
    // ai讲次id
    aiLessonId: [Number, String],
    lessonId: [Number, String],
    // 班型id
    classTypeId: [Number, String],
    // 分组id
    companionUserGroupId: [Number, String]
  },
  data() {
    return {
      bodyStyle: {
        padding: 0
      }
    }
  },
  components: {
    VideoPlayer
  },

  methods: {
    onClose() {
      this.$emit('update:visible', false)
      this.$emit('onSuccess')
    },
    onSuccess() {
      this.onClose()
    }
  }
}
</script>
